import { render, staticRenderFns } from "./MMP_HomeButton.vue?vue&type=template&id=c981b3ec&scoped=true&"
import script from "./MMP_HomeButton.vue?vue&type=script&lang=js&"
export * from "./MMP_HomeButton.vue?vue&type=script&lang=js&"
import style0 from "./MMP_HomeButton.vue?vue&type=style&index=0&id=c981b3ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c981b3ec",
  null
  
)

export default component.exports